<template>
  <el-dialog
    title="添加使用记录"
    :visible.sync="visible"
    width="700px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      size="small"
      label-width="100px"
      :rules="rules"
      :model="model"
      class="fix-width"
      inline
    >
      <!-- <el-form-item label="成品分类" prop="product_template_id">
        <ProductTemplateSelect
          v-model="model.product_template_id"
          :category="model.add_type - 1"
        ></ProductTemplateSelect>
      </el-form-item> -->
      <!-- <el-form-item label="成品编号" prop="product_code">
        <el-input v-model.trim="model.product_code"></el-input>
      </el-form-item> -->
      <el-form-item label="成品编号" prop="product_id">
        <ProductSelect
          v-model="model.product_id"
          :category="model.add_type - 1"
        ></ProductSelect>
      </el-form-item>
      <el-form-item label="使用日期" prop="used_date">
        <el-date-picker
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.used_date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工作时长" prop="used_hour">
        <el-input-number v-model="model.used_hour"></el-input-number>
      </el-form-item>
      <el-form-item
        label="井号"
        prop="drill_well_id"
        v-if="model.add_type == 3"
      >
        <DrillWellSelect
          v-model="model.drill_well_id"
          @info="model.used_extra = getRecordExtrainfo($event)"
        ></DrillWellSelect>
      </el-form-item>
      <el-form-item
        v-else
        :label="param.label"
        v-for="param in model.used_extra"
        :key="param.key"
      >
        <el-input v-model="param.value"></el-input>
      </el-form-item>
      <el-form-item label="备注" class="long">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="图片" class="long">
        <el-upload
          class="upload-small"
          multiple
          :action="actionUrl"
          :headers="uploadHeader"
          :on-error="handleUploadError"
          :on-remove="handleOnRemove"
          :on-success="handleOnSuccess"
          list-type="picture-card"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="视频" class="long">
        <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productRecordNew, productRecordUpdate } from '@/service/getData'
import { urlPerfix } from '@/config/env'
import store from '@/store/index'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      actionUrl: urlPerfix + '/files/upload',
      uploadHeader: { Token: store.state.userInfo.token },
      visible: this.show,
      submiting: false,
      rules: {
        product_template_id: [
          { required: true, message: '请选择成品分类', trigger: 'change' },
        ],
        product_id: [
          { required: true, message: '请选择成品', trigger: 'change' },
        ],
        product_code: [
          { required: true, message: '请填写成品编号', trigger: 'change' },
        ],
        used_date: [
          { required: true, message: '请选择使用日期', trigger: 'change' },
        ],
        used_hour: [
          { required: true, message: '工作时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '工作时长不能为0',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          if (this.model.id > 0) {
            let res = await productRecordUpdate(this.model)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await productRecordNew(this.model)
            if (res.status == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        }
      })
    },
    handleUploadError(err) {
      this.$message({
        message: '上传失败，请重试',
        type: 'error',
        center: true,
      })
    },
    handleOnRemove(file) {
      let index = this.model.imgs.indexOf(file.response.data)
      this.model.imgs.splice(index, 1)
    },
    handleOnSuccess(res, file) {
      this.model.imgs.push(res.data)
    },
  },
}
</script>
